(function () {
  const root = document.querySelector('[data-product-story]');
  if (!root) return;

  function track(name, data) {
    if (window.BcosAnalytics && typeof window.BcosAnalytics.track === 'function') {
      window.BcosAnalytics.track(name, data || {}, 'analytics');
    }
  }

  /* ---------------------------------------------------------- */
  /* Before / after comparison slider                            */
  /* ---------------------------------------------------------- */
  root.querySelectorAll('[data-ba-wrap]').forEach((wrap) => {
    const before = wrap.querySelector('[data-ba-before]');
    const handle = wrap.querySelector('[data-ba-handle]');
    if (!before || !handle) return;

    function setPosition(clientX) {
      const rect = wrap.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      before.style.width = `${percent}%`;
      handle.style.left = `${percent}%`;
      handle.setAttribute('aria-valuenow', Math.round(percent));
    }

    wrap.addEventListener('pointerdown', (event) => {
      wrap.setPointerCapture(event.pointerId);
      wrap.classList.add('bcos-story-ba__wrap--active');
      setPosition(event.clientX);
      track('before_after_interaction');
    });
    wrap.addEventListener('pointermove', (event) => {
      if (!wrap.classList.contains('bcos-story-ba__wrap--active')) return;
      setPosition(event.clientX);
    });
    wrap.addEventListener('pointerup', () => wrap.classList.remove('bcos-story-ba__wrap--active'));
    wrap.addEventListener('pointercancel', () => wrap.classList.remove('bcos-story-ba__wrap--active'));

    handle.addEventListener('keydown', (event) => {
      const step = event.key === 'ArrowLeft' ? -5 : event.key === 'ArrowRight' ? 5 : 0;
      if (!step) return;
      event.preventDefault();
      const current = parseFloat(before.style.width) || 50;
      const rect = wrap.getBoundingClientRect();
      setPosition(rect.left + (current + step) * rect.width / 100);
      track('before_after_interaction');
    });
  });

  /* ---------------------------------------------------------- */
  /* Subtle reveal-on-scroll                                     */
  /* ---------------------------------------------------------- */
  const enableAnimations = root.dataset.animations === 'true';
  if (enableAnimations && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const items = [...root.querySelectorAll('[data-story-cta]')];
    // Keep animations minimal — CTA pulse only.
    items.forEach((cta) => cta.classList.add('bcos-story__cta--pulse'));
  }

  /* ---------------------------------------------------------- */
  /* Analytics: track expanded / viewed story blocks             */
  /* ---------------------------------------------------------- */
  root.querySelectorAll('[data-story-cta]').forEach((cta) => {
    cta.addEventListener('click', () => track('story_cta_clicked'));
  });

  let observed = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const block = entry.target;
      if (observed.has(block)) return;
      observed.add(block);
      track('story_section_viewed', { type: block.dataset.storyType || 'unknown' });
    });
  }, { threshold: 0.4 });

  root.querySelectorAll('[data-story-block]').forEach((block) => observer.observe(block));
})();
